<!-- Header -->

<header class="border-b border-[#191E20] bg-[#fdfdfdf2]">
  <section
    class="mx-auto max-w-[1440px] flex justify-between gap-2 items-center px-[10px] pt-[20px] md:pt-[40px] lg:pr-[74px] pb-[20px] md:pb-[26px] lg:pl-[60px]">
    <a href="/home">
      <img src="assets/logo/ionia_logo.svg" alt="logo" />
    </a>
    <a
      routerLink="/auth/sign-in"
      class="border border-black text-[#191E20] font-semibold px-8 py-2 rounded-full hover:bg-blue-50">
      Login
    </a>
  </section>
</header>

<!-- Hero Section -->
<section class="relative overflow-hidden bg-[#fdfdfd]">
  <div
    class="mx-auto max-w-[1440px] relative z-[2] flex flex-col lg:flex-row justify-between items-center gap-y-4 px-[10px] pt-[67px] lg:pr-[133px] pb-[52px] lg:pl-[90px]">
    <div class="max-w-[758px] text-[#191E20]">
      <h1 class="text-[40px] md:text-[64px] font-medium mb-4 md:leading-none">
        Welcome to IoniaPay- Let's get started
      </h1>
      <p class="max-w-[553px] text-[20px]">
        Your application is the first step toward accessing a purpose-built platform for modern commerce.
      </p>
    </div>
    <button
      (click)="handleToApply()"
      class="text-white px-6 bg-gradient-to-br from-indigo-500 to-indigo-900 rounded-full h-11">
      Begin your application
    </button>
  </div>
  <img
    src="/assets/landing_images/background-glow.webp"
    loading="eager"
    width="1440"
    sizes="(max-width: 1439px) 100vw, 1440px"
    alt=""
    srcset="
      /assets/landing_images/background-glow-p-500.webp   500w,
      /assets/landing_images/background-glow-p-800.webp   800w,
      /assets/landing_images/background-glow-p-1080.webp 1080w,
      /assets/landing_images/background-glow-p-1600.webp 1600w,
      /assets/landing_images/background-glow-p-2000.webp 2000w,
      /assets/landing_images/background-glow-p-2600.webp 2600w,
      /assets/landing_images/background-glow.webp        2880w
    "
    class="background-glow" />
</section>

<!-- Shared Gradient Background for Two Sections -->
<div class="text-[#191E20] bg-[#e2e7fb]">
  <div
    class="mx-auto max-w-[1440px] px-[10px] pt-[50px] md:pt-[94px] lg:pr-[104px] pb-[50px] md:pb-[100px] lg:pl-[90px]">
    <!-- What to Expect Section -->
    <section class="relative">
      <img src="/assets/icons/corner_icon_1.svg" alt="Here's what to expect" class="w-[39px] h-[39px] absolute" />

      <h2 class="text-[40px] font-medium mb-4 ml-[30px] pt-[10px]">Here's what to expect</h2>
      <p class="text-[20px] ml-[40px] mb-8">As you begin the onboarding process, here are the upcoming steps:</p>
      <div class="grid lg:grid-cols-3 gap-6">
        <div class="bg-white rounded-[35px] rounded-br-none py-[30px] pr-[24px] pl-[34px] shadow-md">
          <img src="/assets/landing_images/verification.svg" alt="Verification" class="mb-2" />
          <h3 class="text-[32px] font-medium mb-2">Verification</h3>
          <p class="text-black text-xl">
            All owners/officers will receive an email and text message for identity verification. Respond to both
            promptly to finalize your application.
          </p>
        </div>
        <div class="bg-white rounded-[35px] rounded-br-none py-[30px] pr-[24px] pl-[34px] shadow-md">
          <img src="/assets/landing_images/underwriting_review.svg" alt="Review" class="mb-2" />
          <h3 class="text-[32px] font-medium mb-2">Underwriting review</h3>
          <p class="text-black text-xl">
            We typically complete reviews and provide a decision within 2-3 business days.
          </p>
        </div>
        <div class="bg-white rounded-[35px] rounded-br-none py-[30px] pr-[24px] pl-[34px] shadow-md">
          <img src="/assets/landing_images/assistance.svg" alt="Assistance" class="mb-2" />
          <h3 class="text-[32px] font-medium mb-2">Further assistance</h3>
          <p class="text-black text-xl">If we need anything else, w'll let your sales agent know.</p>
        </div>
      </div>
    </section>

    <!-- Requirements Section -->
    <section class="pt-[50px] md:pt-[115px]">
      <h2 class="text-[40px] font-medium mb-4">Before you begin, here's what you'll need</h2>
      <p class="text-xl mb-10 lg:w-[950px]">
        Gather these required documents. You can save your progress during the application process and return when
        ready.
      </p>
      <div class="flex flex-col lg:flex-row gap-12">
        <div
          class="max-w-[663px] bg-white rounded-[35px] rounded-br-none p-[20px] md:py-[38px] md:pr-[85px] md:pl-[53px] shadow-md">
          <ul
            class="space-y-6 list-image-[url('/assets/landing_images/list_requirement_icon.png')] text-[25px] md:text-[32px] ml-[25px] font-medium">
            <li class="pl-4">
              Government-issued ID
              <p class="text-[18px] md:text-[20px] font-normal">
                For all beneficial owners (passport, driver's license, or state ID)
              </p>
            </li>
            <li class="pl-4">
              Company documents
              <p class="text-[18px] md:text-[20px] font-normal">
                DBA name if applicable, EIN documents, signed Certificate of Beneficial Owners Form
              </p>
            </li>
            <li class="pl-4">3 months of prior processing or history statements</li>
            <li class="pl-4">A voided check</li>
            <li class="pl-4">
              Certificate of Good Standing
              <p class="text-[18px] md:text-[20px] font-normal">Applies if your business was formed in DE, WV, or NJ</p>
            </li>
          </ul>
        </div>
        <img
          src="/assets/landing_images/requirements.png"
          alt="helping"
          class="rounded-full w-auto h-auto lg:max-w-[414px] lg:max-h-[534px] mx-auto my-auto" />
      </div>
      <p class="mt-12 ml-6 text-2xl font-medium">
        Visit our
        <a href="https://www.ioniapay.com/faqs/merchant-faqs" class="text-blue-600 underline cursor-pointer">
          Merchant FAQ
        </a>
        page for more information.
      </p>
    </section>
  </div>
</div>

<!-- Unlock Full Potential Section -->
<section class="bg-white">
  <div
    class="mx-auto max-w-[1440px] flex flex-col lg:flex-row justify-between gap-12 items-center px-0 py-[25px] md:py-[150px]">
    <div class="max-w-[680px] px-[10px] lg:pl-[90px] md:px-0 relative">
      <img src="/assets/icons/corner_icon_2.svg" alt="Here's what to expect" class="w-[39px] h-[39px] absolute" />
      <h2 class="text-[35px] md:text-[53px] font-medium mb-4 ml-[30px] pt-[10px]">
        Unlock the full potential of IoniaPay's complete payment ecosystem
      </h2>
      <p class="text-[20px] mb-8 max-w-[572px] ml-[40px]">
        Your business, your way. IoniaPay offers flexible integration options to connect with your current systems,
        ensuring a smooth transition and immediate access to our powerful platform benefits.
      </p>
      <button
        (click)="handleToApply()"
        class="text-white px-6 bg-gradient-to-br from-indigo-500 to-indigo-900 rounded-full h-11 ml-[40px]">
        Begin your application
      </button>
    </div>
    <div class="flex justify-center self-end gap-8">
      <img src="/assets/landing_images/dashboard.svg" alt="dashboard" class="w-[400px]" />
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="bg-gradient-to-b from-[#32447F] to-[#000000] text-white">
  <div class="max-w-[1440px] mx-auto py-8 px-[10px] lg:pl-[86px] lg:pr-[114px]">
    <div class="flex flex-col md:flex-row justify-between items-start md:items-end">
      <img src="/assets/logo/ionia_logo_light.png" alt="IONIQPay logo" class="mb-8 md:mb-0" />
      <div class="flex flex-col md:flex-row gap-y-4 gap-x-16">
        <a routerLink="/auth/sign-up" class="hover:underline">Apply</a>
        <a routerLink="/auth/sign-in" class="hover:underline">Login</a>
        <a (click)="isContactVisible = true" class="cursor-pointer hover:underline">Contact us</a>
      </div>
    </div>

    <hr class="border-t border-[#B6B8C0] my-6" />

    <div class="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 text-xs font-mediumspace-y-2">
      <div>
        <p class="mb-2">© Ionia 2025, All Rights Reserved.</p>
        <p>
          Covered by U.S. Patent No. 10,395,234 and one or more other pending applications.
          <br />
          Banking, Payments, and Card services are provided by Ionia's partner banks that are members of the FDIC.
        </p>
      </div>
      <div class="whitespace-nowrap">
        <a href="https://fileshare.ioniapay.com/dl/AOxDSXjiVE" class="hover:underline">Terms of Service</a>
        &nbsp;|&nbsp;
        <a href="https://fileshare.ioniapay.com/dl/2D3C2nHwb4/Ionia_Pay_Privacy_Policy.pdf_" class="hover:underline">
          Privacy Policy
        </a>
      </div>
    </div>
  </div>
</footer>

<p-dialog
  [(visible)]="isContactVisible"
  [style]="{ width: contactModalWidth }"
  [modal]="true"
  position="center"
  [header]="contactModalTitle">
  <div *ngIf="isVideo; else other_content">
    <div class="video-container">
      <div style="padding: 56.25% 0 0 0; position: relative">
        <iframe
          src="https://player.vimeo.com/video/985205720?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
          title="OpenPath x IoniaPay Sales Demo"></iframe>
      </div>
    </div>
  </div>

  <ng-template #other_content>
    <form [formGroup]="contactForm" (ngSubmit)="contactSubmit()" class="profile-form">
      <div class="flex items-start justify-start flex-col">
        <div class="mb-4 w-full">
          <label class="block text-gray-700 text-sm mb-2" for="email">Name</label>
          <input
            class="input shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            formControlName="name" />
          <div
            *ngIf="f['name'].invalid && (f['name'].dirty || f['name'].touched)"
            class="text-red-500 text-xs font-normal italic mt-1">
            <div *ngIf="f['name'].errors?.['required']">Name is required</div>
          </div>
        </div>
        <div class="mb-4 w-full">
          <label class="block text-gray-700 text-sm mb-2" for="email">Email</label>
          <input
            class="input shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="email"
            type="text"
            formControlName="email" />
          <div
            *ngIf="f['email'].invalid && (f['email'].dirty || f['email'].touched)"
            class="text-red-500 text-xs font-normal italic mt-1">
            <div *ngIf="f['email'].errors?.['required']">Email is required</div>
            <div *ngIf="f['email'].errors?.['email']">Email must be a valid email address</div>
          </div>
        </div>
        <div class="mb-4 w-full">
          <label class="block text-gray-700 text-sm mb-2" for="email">Message</label>
          <textarea
            class="input shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="message"
            type="text"
            formControlName="message"
            rows="4"></textarea>
          <div
            *ngIf="f['message'].invalid && (f['message'].dirty || f['message'].touched)"
            class="text-red-500 text-xs font-normal italic mt-1">
            <div *ngIf="f['message'].errors?.['required']">Message is required</div>
          </div>
        </div>
        <div class="flex justify-between w-full">
          <a
            (click)="contactCancel()"
            class="bg-white py-2 mr-2 flex items-center justify-center rounded-full gap-x-2 text-base font-semibold border border-[#DBDBDB] cursor-pointer w-[130px] h-[52px]">
            Cancel
          </a>
          <div
            class="bg-slate-800 pl-6 hover:bg-slate-900 transition-colors duration-100 text-white flex items-center rounded-full gap-x-2 w-[140px]">
            <a (click)="contactSubmit()" class="text-base font-medium py-2 cursor-pointer flex items-center">
              Submit
              <img src="assets/landing_images/layer_button.svg" alt="layer_button" class="h-10 w-10 pl-2" />
            </a>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</p-dialog>
